import React from "react";
import { Timezone } from "../../utilis/dateTime";

export interface TimezoneContextType {
  timezone: Timezone;
  setTimezone: (timezone: Timezone) => void;
}

const TimezoneContext = React.createContext<TimezoneContextType>(undefined!);

export interface TimezoneProviderProps extends React.PropsWithChildren {
  defaultTimezone?: Timezone;
}

export default function TimezoneProvider(props: TimezoneProviderProps) {
  const [timezone, setTimezone] = React.useState<Timezone>(() => {
    if (props.defaultTimezone) {
      return props.defaultTimezone;
    }

    const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const matchingTimezone = Object.values(Timezone).find(
      (tz) => tz === detectedTimezone
    );

    if (matchingTimezone) {
      return matchingTimezone;
    }

    return Timezone.LONDON;
  });

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {props.children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  const context = React.useContext(TimezoneContext);

  if (context === undefined) {
    throw new Error("useTimezone must be used within a TimezoneProvider");
  }

  return context;
}
